import styled from 'styled-components';

export const QuestionNumber = styled.div`
  border-right: 2px solid ${props => props.theme.color.grey[8]};
  padding-right: 24px;
  white-space: nowrap;
`;

export const QuestionContainer = styled.div`
  margin: -20px 24px 0 24px;
  max-width: 100%;
`;

export const OptionContainer = styled.button`
  margin: 0;
  border: none;
  background: none;
  outline: none;
  width: 100%;
  cursor: pointer;
  border-radius: 8px;
  padding: 24px 12px;
  display: flex;
  align-items: center;
  text-align: left;

  &:hover {
    box-shadow: ${props => props.theme.shadow[3]};

    label > span:first-of-type {
      background-color: ${props => props.theme.color.blue['2']};
    }
  }
`;

export const HeaderContainer = styled.div`
  display: flex;
  flex-direction: column;
  align-items: ${props => (props.sample ? 'flex-start' : 'center')};
  margin: 48px auto;
`;
